/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalProduct =
  typeof InternalProduct[keyof typeof InternalProduct];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalProduct = {
  SAVINGS_EXCHANGE: 'SAVINGS_EXCHANGE',
} as const;
